import React from "react";
import CalendarWrapper from "../CalendarWrapper";
import { useTheme } from "../../contexts/ThemeContext.jsx";

const ZeiterfassungWidget = ({
  currentWeek,
  timeEntries,
  contracts,
  selectedEmployee,
}) => {
  const { getComputedThemeValue } = useTheme();

  if (!selectedEmployee) {
    return (
      <div className="widget-placeholder">
        Kein:e Mitarbeiter:in ausgewählt.
      </div>
    );
  }

  return (
    <div className="widget-content-scroll">
      <CalendarWrapper
        currentWeek={currentWeek || new Date()}
        setCurrentWeek={() => {}}
        selectedCells={[]}
        setSelectedCells={() => {}}
        onCreateEntry={() => {}}
        onDeleteEntry={() => {}}
        timeEntries={timeEntries || []}
        contracts={contracts || []}
        loading={false}
        themeValues={{
          backgroundColor: getComputedThemeValue("--background-color"),
          textColor: getComputedThemeValue("--text-color"),
          textBgColor: getComputedThemeValue("--text-bg-color"),
          projectColor: getComputedThemeValue("--main-color"),
          projectBgColor: getComputedThemeValue("--second-color"),
        }}
      />
    </div>
  );
};

export default ZeiterfassungWidget;
